import React, { useEffect } from "react"

// Utils
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

// Components
import MobileLogin from "src/components/pages/login/mobile"
import DesktopLogin from "src/components/pages/login/desktop"

// Hooks
import { useIsMobile } from "src/hooks/useIsMobile"
import Head from "next/head"
import { useRouter } from "next/router"
import auth from "../../lib/auth"
import Pages from "../../constants/pages"

// -------------------------------------------|| LOGIN - PAGES ||-------------------------------------------------------

const Login = () => {
  const isMobile = useIsMobile()
  const router = useRouter()

  useEffect(() => {
    auth.ensureSession().then(isValid => {
      if (isValid) router.push(Pages.Main)
    })
  }, [])

  return (
    <>
      <Head>
        <title>ورود به حساب کاربری</title>
      </Head>
      {isMobile ? <MobileLogin /> : <DesktopLogin />}
    </>
  )
}

export default Login

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
